import mutations from './mutations'
import { isEmpty, cloneDeep } from 'lodash'
import WorkbenchWCanvasBaseStore from '@/views/workbenchCanvas/store/WorkbenchWCanvasBaseStore'
import WorkbenchActions from './actions'
import {isActivationBlocked, isTargetOwnedBy} from '@/helpers'
import RevisionHistoryStore from '@/appLogic/revisionHistory/store'

class StoreSM extends WorkbenchWCanvasBaseStore {

  additionalState () {
    return {
      canvas: {
        audienceSize: null,
        topSocialAffinity: [],
        topTsp: [],
        reach: null
      }
    }
  }

  additionalGetters () {
    return {
      targetDefinition: (state, getters) => ({
        query: getters.serializedDefinition,
        viewSource: getters.streamingOption
      }),
      audienceSize: state => state.canvas.audienceSize,
      // TODO: tsp and gigya attributes should have their corresponding dataset id
      // in which it comes from but this is a to do later on when data on backend is updated
      topTsp: (state, getters) => typeof state.canvas.topTsp === 'object' ? state.canvas.topTsp.map(o => {
        // make sure to clone the original so we aren't modifying the state
        let newO = cloneDeep(o)
        newO.dataset = 'tsp'
        newO.attribute = getters.getAttributeForIdDataset(newO)
        return newO
      }) : undefined,
      isTargetArchived: (state, getters) => {
        if (isEmpty(getters.currentTarget)) return false
        return getters.currentTarget.archived
      },
      topSocialAffinity: (state, getters) => {
        if (typeof state.canvas.topSocialAffinity === 'object') {
          return state.canvas.topSocialAffinity.map(o => {
            // attribute could be in gigya_favs or gigya_likes
            // make sure to clone the original so we aren't modifying the state
            let newO = cloneDeep(o)
            newO.dataset = 'gigya_likes'
            newO.attribute = getters.getAttributeForIdDataset(newO)
            // if we do not find an attribute in likes we then try favs
            if (!newO.attribute) {
              newO.dataset = 'gigya_favs'
              newO.attribute = getters.getAttributeForIdDataset(newO)
            }
            return newO
          })
        } else {
          return undefined
        }
      },
      reach: state => state.canvas.reach,
      showGenerateEstimate: (state, getters) => {
        let target = getters.currentTarget
        if (target.display_name) {
          let activationBlocked = isActivationBlocked(target.target)
          let cantShow = target.activated || !isTargetOwnedBy(target, getters.username) || activationBlocked
          return !cantShow
        } else {
          return false
        }
      }
    }
  }

  additionalMutations () {
    return mutations
  }

  additionalModules () {
    const modules = {
      RevisionHistoryStore
    }
    return modules
  }

  createActions () {
    const WorkbenchActionsSM = new WorkbenchActions()
    WorkbenchActionsSM.setNamespace(this.namespace)
    return WorkbenchActionsSM.createActions()
  }
}

const module = function (namespace) {
  return new StoreSM(namespace).create()
}
export default module



// WEBPACK FOOTER //
// ./src/app/views/workbench/SM/store/index.js